import { FileConfigOptions } from '@dirootie-core/core';
import { ILogger } from '@dirootie-logging/logging-types';
import { FileConfigurationProvider } from '../../File';
import { IAppModule, IServiceProvider } from './modules.types';

export class SettingsModule implements IAppModule {
  name = 'settings';

  constructor(protected options: FileConfigOptions) {}

  configureServices(serviceProvider: IServiceProvider): void {
    const logger = serviceProvider.resolve<ILogger>('logger')!;
    const configProvider = new FileConfigurationProvider(logger, this.options);
    configProvider.loadSync();
    serviceProvider.register('config-provider', configProvider);
  }
}
